import React from 'react';
import { Modal, Tabs, Tab, Card, Badge, Button } from 'react-bootstrap';

interface Props {
    show: boolean;
    onHide: () => void;
    loadedItems: any[];
    plannedItems: any[];
}

const LoadedItemsModal: React.FC<Props> = ({ show, onHide, loadedItems, plannedItems }) => {
    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Sevkiyat İçerik Detayı</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Tabs defaultActiveKey="loaded" className="mb-3">
                    <Tab eventKey="loaded" title={`Yüklenen (${loadedItems.length})`}>
                        {loadedItems.length === 0 && <div className="text-muted p-3 text-center">Henüz ürün yüklenmemiş.</div>}
                        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            {loadedItems.map((item, idx) => (
                                <Card key={idx} className="mb-2 p-2 shadow-sm border-start border-success border-4">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <div className="fw-bold">{item.productName}</div>
                                            <div className="small text-muted">Depo: {item.warehouseName} | Palet: {item.palletIndex}</div>
                                        </div>
                                        <Badge bg="success">{item.quantity} Adet</Badge>
                                    </div>
                                </Card>
                            ))}
                        </div>
                    </Tab>
                    <Tab eventKey="planned" title={`Planlanan (${plannedItems.length})`}>
                        {plannedItems.length === 0 && <div className="text-muted p-3 text-center">Plan bulunamadı.</div>}
                        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            {plannedItems.map((item, idx) => (
                                <Card key={idx} className="mb-2 p-2 shadow-sm border-start border-primary border-4">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <div className="fw-bold">{item.productName || item.product?.description}</div>
                                            {item.buyerName && <div className="small text-muted">Alıcı: {item.buyerName}</div>}
                                        </div>
                                        <Badge bg="primary">{item.quantity || item.plannedQuantity} Adet</Badge>
                                    </div>
                                </Card>
                            ))}
                        </div>
                    </Tab>
                </Tabs>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Kapat</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default LoadedItemsModal;